"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = exports.defaultComponent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var theme_1 = __importDefault(require("../../../styles/theme"));
var Typography_styles_1 = __importDefault(require("./Typography.styles"));
var defaultVariant = 'body';
// We do not use h1, h2, h3 because we use the different levels solely for their different looks.
// Using h1, h2, h3 appropriately would require more work (e.g. make sure that we don't skip levels).
// We do not use <p> because we rarely render paragraphs of text.
exports.defaultComponent = 'div';
/**
 * Typography atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-typography--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Typography Source}
 */
exports.Typography = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var _c = _a.component, component = _c === void 0 ? exports.defaultComponent : _c, className = _a.className, children = _a.children, color = _a.color, _d = _a.variant, variant = _d === void 0 ? defaultVariant : _d, bold = _a.bold, underline = _a.underline, noWrap = _a.noWrap, hoverVariant = _a.hoverVariant, numberOfLines = _a.numberOfLines, overflowEllipsis = _a.overflowEllipsis, textAlign = _a.textAlign, transition = _a.transition, breakAll = _a.breakAll, breakWord = _a.breakWord, other = __rest(_a, ["component", "className", "children", "color", "variant", "bold", "underline", "noWrap", "hoverVariant", "numberOfLines", "overflowEllipsis", "textAlign", "transition", "breakAll", "breakWord"]);
    var classes = (0, Typography_styles_1.default)();
    var Component = component;
    var defaultTextColor = variant === 'button' ? theme_1.default.textColors.highlight : theme_1.default.textColors.primary;
    var styleOverrides = {
        transition: transition,
        color: color || defaultTextColor,
        fontWeight: bold ? 'bold' : undefined,
        textDecoration: underline ? 'underline' : undefined,
        textAlign: textAlign,
        WebkitLineClamp: numberOfLines === null || numberOfLines === void 0 ? void 0 : numberOfLines.toString(),
    };
    return ((0, jsx_runtime_1.jsx)(Component, __assign({ className: (0, classnames_1.default)(className, classes[variant], (_b = {},
            _b[classes.noWrap] = noWrap,
            _b[classes.hoverError] = hoverVariant === 'error',
            _b[classes.hoverDefault] = hoverVariant === 'default',
            _b[classes.hoverDark] = hoverVariant === 'dark',
            _b[classes.hoverErrorDark] = hoverVariant === 'errorDark',
            _b[classes.hoverOpacity] = hoverVariant === 'opacity',
            _b[classes.hoverUnderline] = hoverVariant === 'underline',
            _b[classes.clip] = numberOfLines,
            _b[classes.overflowEllipsis] = overflowEllipsis,
            _b[classes.breakAll] = breakAll,
            _b[classes.breakWord] = breakWord,
            _b)), style: styleOverrides, ref: ref }, other, { children: children })));
});
